import React, { useMemo } from "react";
import { Chart } from "react-google-charts";
import PerformanceOverTimeInHeatmap from "./PerformanceOverTimeInHeatmap";
import styles from "./PerformanceOverTime.module.css";

const PerformanceOverTime = ({ data }) => {
    // Default data to prevent undefined errors
    const defaultChartData = [["Date", "Accepted", "Sent", "Delivered", "Read"], ["2025-03-17", 0, 0, 0, 0]];

    const chartData = useMemo(() => {
        if (!data || data.length === 0) {
            return defaultChartData; // If no data, return default structure
        }

        const timeCounts = {};

        data.forEach((item) => {
            ["acceptedOn", "sentOn", "deliveredOn", "readOn"].forEach((key) => {
                if (item[key] && item[key] !== "0000-00-00 00:00:00") {
                    const date = item[key].split(" ")[0]; // Extract only the date

                    if (!timeCounts[date]) {
                        timeCounts[date] = [date, 0, 0, 0, 0]; // Initialize row with date
                    }

                    const index = { acceptedOn: 1, sentOn: 2, deliveredOn: 3, readOn: 4 }[key];
                    timeCounts[date][index] += 1; // Increment count for the status
                }
            });
        });

        const sortedData = Object.values(timeCounts).sort((a, b) => new Date(a[0]) - new Date(b[0]));
        return sortedData.length > 0 ? [["Date", "Accepted", "Sent", "Delivered", "Read"], ...sortedData] : defaultChartData;
    }, [data]);

    return (
        <div className={styles.card}>
            {/* Column Chart */}
            <h3 className={styles.cardHeading}>Daily Message Breakdown</h3>
            <Chart
                width={"100%"}
                height={"350px"}
                chartType="ColumnChart"
                loader={<div>Loading Chart...</div>}
                data={chartData}
                options={{
                    title: "Daily Messages Performance",
                    hAxis: { title: "Date" },
                    vAxis: { title: "Messages Count" },
                    legend: { position: "top" },
                    seriesType: "bars",
                    colors: ["#8884d8", "#82ca9d", "#ff7300", "#ff0000"]
                }}
            />

            <PerformanceOverTimeInHeatmap data={data} />
        </div>
    );
};

export default PerformanceOverTime;
